// initial state for filters slice declared here
const initialState = {
    status: 'All',
    filterText: '',
};

export default initialState;